module.exports = __webpack_public_path__ + "img/cotizacion_3.4cae1e44.png";